import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Popover from 'react-awesome-popover';
import Select2 from 'react-select2-wrapper';
import moment from 'moment';
import 'moment/locale/de';

class ChangeShift extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            supporter: null
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleSelectSupporter = this.handleSelectSupporter.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleOpen() {
        this.setState({
            open: true
        })
    }

    handleSelectSupporter(e) {
        this.props.handleSelectSupporter(e.target.value);
        this.handleClose();
    }

    handleClose() {
        this.setState({
            open: false
        });
    }

    render() {
        const { t } = this.props;
        return (
            <Popover targetClass="btn btn-default btn-xs" onOpen={this.loadAvailableShifts} open={this.state.open} contentClass="rap-popover-content">
                <i className="fa fa-plus"/>
                <div className="p-md" style={{width: 300, textAlign: 'left'}}>
                    <div
                        className="form-group">
                        <label>{t('supporterShifts.shift.label')}</label>
                        <Select2 data={this.props.supporters.map((el) => {
                            return {
                                text: el.name, id: el.id
                            }
                        })} value={this.state.supporter} onChange={this.handleSelectSupporter} name="supporter"
                                 options={{placeholder: 'Supporter:in wählen...'}}
                                 className="width-100p block"/>
                    </div>
                </div>
            </Popover>
        )
    }
}

export default translate()(ChangeShift);